type ExtractTotalEffortParams = {
  findings: {
    effort: number;
  }[];
};

// Calculating total time to remediate a list of aggregate scores or findings
export function extractTotalEffort({ findings }: ExtractTotalEffortParams) {
  return (
    findings.reduce((acc, curr) => {
      return acc + (curr?.effort || 0);
    }, 0) || 0
  );
}
